import { useMemo } from 'react';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { useSelector } from 'react-redux';
import { getTakenCourses } from 'containers/Course/selectors';
import { getCourseSeries } from 'containers/Course/utils';

const useCourseProgress = item => {
  const takenCourses = useSelector(getTakenCourses);

  const taken = takenCourses[item.id];
  const courseSeries = useMemo(() => getCourseSeries({ fields: item }), [item]);

  if (_isEmpty(taken)) return 0;
  if (taken.completed) return 100;

  const completedNumberOfSeries = _get(taken, 'completedSeriesIds', []).length;
  const totalNumberOfSeries = courseSeries.length;
  const progress = Math.round(
    (completedNumberOfSeries / (totalNumberOfSeries || 1)) * 100,
  );

  return progress;
};

export default useCourseProgress;
